import ACTION_NAMES from "actions/ACTION_NAMES";
import types from "actions/call/types";
import CRUD_ACTION_TYPES, { getNamedAction } from "actions/CRUD_ACTION_TYPES";
import initialState from "./state";

function callReducer(state = initialState, action) {
    switch (action.type) {
        case getNamedAction(ACTION_NAMES.TRANSFER, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isTransferringCall: true };
        case getNamedAction(ACTION_NAMES.TRANSFER, CRUD_ACTION_TYPES.CREATE_SUCCESS):
            return { ...state, isTransferringCall: false };
        case getNamedAction(ACTION_NAMES.TRANSFER, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isTransferringCall: false };

        case 'RECEIVE_CALL':
            return { ...state, isCalling: true, callIsActive: true, channel_uuid: action.channel_uuid };

        case 'ANSWER_CALL':
            return { ...state, isCalling: false, callIsActive: true };

        case types.RESOLVE_CALL_RESULT:
            return { ...state, isResolvingCallResult: false, callIsActive: false };

        case getNamedAction(ACTION_NAMES.VM_DROP, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isDroppingVoicemail: true };
        case getNamedAction(ACTION_NAMES.VM_DROP, CRUD_ACTION_TYPES.CREATE_SUCCESS):
            return { ...state, isDroppingVoicemail: false };
        case getNamedAction(ACTION_NAMES.VM_DROP, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isDroppingVoicemail: false };

        default:
            return state;
    }
}


export default callReducer;
